
// Dependencies
import axios from 'axios';
import { AxiosInstance } from 'axios';
import { Subject } from 'rxjs';

// Local
import config from './config';

class ApiClient
{
	// Fields

	private api: AxiosInstance;



	// Public properties

	public loading = new Subject <boolean> ();



	// Constructor

	constructor (config: any)
	{
		this.api = axios.create ({ baseURL: config.url });
	}



	// Methods

	async confirmRegistration (id: string)
	{
		return await this.get ('/tag/confirmRegistration', { id });
	}

	async getTag (id: string) : Promise <any>
	{
		return await this.get ('/tag/get', { id });
	}

	async notifyScan (data: any)
	{
		return await this.post ('/tag/notifyScan', data);
	}

	async notifyFound (data: any)
	{
		return await this.post ('/tag/notifyFound', data);
	}

	async registerTag (data: any) : Promise <any>
	{
		return await this.post ('/tag/register', data);
	}

	async upload (file: any)
	{
		const info = await this.post ('/file/requestUpload', { type: file.type });
		try
		{
			this.loading.next (true);
			const options = { headers: { 'Content-Type': file.type } };
			await this.api.put (info.url, file, options);
			return info.uuid;
		}
		finally
		{
			this.loading.next (false);
		}
	}



	// Private

	checkResponse (response: any) : any
	{
		if (!response.data)
			throw new Error ('No response data');
		if (response.data.error)
			throw new Error (response.data.error);
		return response.data.result;
	}

	async get (path: string, parameters: any = null) : Promise <any>
	{
		try
		{
			this.loading.next (true);
			const response = await this.api.get (path, { params: parameters });
			return this.checkResponse (response);
		}
		finally
		{
			this.loading.next (false);
		}
	}

	async post (path: string, data: any) : Promise <any>
	{
		try
		{
			this.loading.next (true);
			const response = await this.api.post (path, data);
			return this.checkResponse (response);
		}
		finally
		{
			this.loading.next (false);
		}
	}
}

export default new ApiClient (config.api);
